<app-shared-dialog [title]="'inventory.product_edit_pricing.title' | translate" 
  [options]="{
    titleIcon: 'pen-cc',
    titleIconColor: 'primary',
    confirmText: 'inventory.product_edit_pricing.save' | translate,
    cancelText: 'inventory.product_edit_pricing.cancel' | translate,
    confirmButtonStyle: 'primary-btn',
    customConfirmButton: true
  }" (cancel)="cancel()">

  <div class="pricing-container" [formGroup]="form">
    <div class="currency-block">
      <div class="form-row">
        <label class="field-label">{{ 'inventory.product_edit_pricing.currency' | translate }}</label>
        <div class="currency-select-wrapper">
          <mat-select formControlName="default_currency" [disabled]="true">
            <mat-select-trigger *ngIf="form.get('default_currency')?.value">
                <span class="tag">{{default_currency?.name}} ({{default_currency?.symbol}})</span>
            </mat-select-trigger>
            <mat-option [value]="default_currency">
              {{ default_currency?.name }} ({{ default_currency?.symbol }})
            </mat-option>
          </mat-select>
        </div>
        <div class="delete-wrapper"></div>
      </div>
      <div class="form-row">
        <label class="field-label">{{ 'inventory.product_edit_pricing.retail_price' | translate }}</label>
        <div class="standard-input">
          <input type="number" step="0.01" placeholder="0.00"
            min="0" formControlName="sales_price" (keydown)="preventNegativeInput($event)" />
          <span class="symbol">{{ default_currency?.symbol }}</span>
        </div>
      </div>

      <div class="form-row">
        <label class="field-label">{{ 'inventory.product_edit_pricing.product_cost' | translate }}</label>
        <div class="standard-input">
          <input type="number" step="0.01" formControlName="cost" placeholder="0.00"
             min="0" (keydown)="preventNegativeInput($event)" />
          <span class="symbol">{{ default_currency?.symbol }}</span>
        </div>
      </div>
    </div>
    <div class="currency-block" *ngFor="let currency of addedCurrencies; let i = index">
      <div class="form-row">
        <label class="field-label">{{ 'inventory.product_edit_pricing.currency' | translate }}</label>
        <div class="currency-select-wrapper">
          <mat-select [formControl]="currency.controls.currency">
            <mat-select-trigger *ngIf="currency.controls.currency.value">
                <span class="tag">{{ currency?.data?.name }} ({{ currency?.data?.symbol }})</span>
            </mat-select-trigger>
            <mat-option *ngFor="let opt of getAvailableCurrenciesForSelect(i)" [value]="opt.id">
              {{ opt.name }} ({{ opt.symbol }})
            </mat-option>
          </mat-select>
        </div>
        <div class="delete-wrapper">
          <button class="delete-btn" *appHasPermission="{ module: 'product', action: 'edit' }" (click)="removeCurrency(i)">
            <img src="assets/icones/delete_btn.svg" alt="delete" class="delete-icon" />
          </button>
        </div>
      </div>
      <div class="form-row">
        <label class="field-label">{{ 'inventory.product_edit_pricing.retail_price' | translate }}</label>
        <div class="standard-input" [formGroup]="currency.controls['retail_price']">
          <input type="number" step="0.01" formControlName="amount" placeholder="0.00"
            (keydown)="preventNegativeInput($event)" min="0" />
          <span class="symbol">{{ currency.data.symbol }}</span>
        </div>
      </div>

      <div class="form-row">
        <label class="field-label">{{ 'inventory.product_edit_pricing.product_cost' | translate }}</label>
        <div class="standard-input" [formGroup]="currency.controls['cost']">
          <input type="number" step="0.01" placeholder="0.00" formControlName="amount"
            (keydown)="preventNegativeInput($event)" min="0" />
          <span class="symbol">{{ currency.data.symbol }}</span>
        </div>
      </div>
    </div>

    <ng-container *appHasPermission="{ module: 'product', action: 'edit' }">
      <div class="add-currency" *ngIf="availableCurrencies.length > 0" (click)="addCurrency(undefined)">
        <mat-icon>add</mat-icon>
        <span>{{ 'inventory.product_edit_pricing.add_currency' | translate }}</span>
      </div>
    </ng-container>
  </div>
  <ui-button
    customConfirm
    *appHasPermission="{ module: 'product', action: 'edit' }"
    type="primary"
    [label]="'inventory.product_edit_pricing.save' | translate"
    (click)="save()">
  </ui-button>
</app-shared-dialog>
